<template>
    <el-dialog :visible.sync="visible" title="详情" :close-on-click-modal="false" :close-on-press-escape="false"
        :append-to-body="appendToBody" :destroy-on-close="true">
        <template>
            <el-descriptions title="基本信息" direction="vertical" :column="4" border>
                <el-descriptions-item label="姓名">{{ detailData.xm }}</el-descriptions-item>
                <el-descriptions-item label="性别">{{ detailData.sex }}</el-descriptions-item>
                <el-descriptions-item label="联系方式">{{ detailData.mobile }}</el-descriptions-item>
                <el-descriptions-item label="出生年月">{{ detailData.birth }}</el-descriptions-item>
                <el-descriptions-item label="残疾部位" :span="2">{{ detailData.cjPosition }}</el-descriptions-item>
                <el-descriptions-item label="居住地">{{ detailData.liveAddress }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="就业信息" direction="vertical" :column="4" border style="margin-top: 20px">
                <el-descriptions-item label="是否已就业">{{ detailData.working }}</el-descriptions-item>
                <el-descriptions-item label="是否有就业意向">{{ detailData.hasWorkIntent }}</el-descriptions-item>
                <el-descriptions-item label="就业意向类别">{{ detailData.workIntentType }}</el-descriptions-item>
                <el-descriptions-item label="求职意向">{{ detailData.workIntent }}</el-descriptions-item>
                <el-descriptions-item label="是否有能力就业" :span="2">{{ detailData.workCapable }}</el-descriptions-item>
                <el-descriptions-item label="是否需要残联培训">{{ detailData.requireTraining }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="教育信息" direction="vertical" :column="4" border style="margin-top: 20px">
                <el-descriptions-item label="毕业院校">{{ detailData.school }}</el-descriptions-item>
                <el-descriptions-item label="学历">{{ detailData.educationBackground }}</el-descriptions-item>
                <el-descriptions-item label="专业">{{ detailData.major }}</el-descriptions-item>
            </el-descriptions>
            <div style="display: flex;justify-content: space-between;align-items: center">
                <el-descriptions title="安置就业信息" direction="vertical" :column="4" border style="margin-top: 20px">
                </el-descriptions>
                <el-button style="height: 40px" type="primary" @click="innerVisible = true">添加</el-button>
            </div>


            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="qyxx" label="企业信息" align="center">
                    <template slot-scope="scope">
                        <div>{{scope.row.qyxx}}</div>
                        <div>{{scope.row.gwmc}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="azqk" label="就业安置状况" align="center">
                    <template slot-scope="scope">
                        <div v-html="scope.row.azqk"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" label="日期" align="center"></el-table-column>
            </el-table>

        </template>

        <template slot="footer">
            <el-button type="primary" @click="close()">确定</el-button>
        </template>

        <el-dialog
                width="30%"
                top="10vh"
                title="添加安置信息"
                :visible.sync="innerVisible"
                append-to-body>

                <el-form ref="form" :model="form" :rules="dataRule" label-width="80px">
                    <el-form-item label="企业信息" prop="qyxx">
                        <el-input v-model="form.qyxx"></el-input>
                    </el-form-item>
                    <el-form-item label="岗位名称" prop="gwmc">
                        <el-input v-model="form.gwmc"></el-input>
                    </el-form-item>
                    <el-form-item label="就业安置情况" prop="azqk">
                        <wangEditor v-model="form.azqk"></wangEditor>
                    </el-form-item>
                </el-form>
            <template slot="footer">
                <el-button type="primary" @click="dataFormSubmitHandle()">提交</el-button>
            </template>
        </el-dialog>

    </el-dialog>
</template>

<script>
import wangEditor from "@/components/wangEditor";
export default {
    components: { wangEditor },
    props: {
        appendToBody: {
            type: Boolean,
            require: false,
            default: false
        },
    },
    computed: {
        dataRule () {
            return {
                qyxx: [
                    { required: true, message: '请输入', trigger: 'change' }
                ],
                gwmc: [
                    { required: true, message: '请输入', trigger: 'change' }
                ],
                azqk: [
                    { required: true, message: '请输入', trigger: 'change' }
                ]
            }
        }
    },
    data() {
        return {
            visible: false,
            innerVisible: false,
            dataForm: {
                id: "",
                taskType: "1",
            },
            detailData: {},
            tableData: [],
            form: {
                "qyxx": "",
                "gwmc": "",
                "azqk": ""
            }
        };
    },
    methods: {
        init(row, taskType) {
            console.log(row)
            this.detailData = row
            this.dataForm.taskType = '1'
            this.visible = true;
            this.getTableData()
        },
        getTableData() {
            this.$http.get(
                `/extension/getAzxx?id=${this.detailData.id}`,
            ).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.tableData = res.azxx
            }).catch(() => {})
        },
        close() {
            this.visible = false
            this.innerVisible = false
            this.dataForm={}
        },
        dataFormSubmitHandle() {
            console.log(this.form)
            this.$http.post(
                `/extension/addAzxx`,
                {...this.form, id: this.detailData.id}
            ).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                        this.innerVisible = false
                        this.getTableData()
                    }
                })

            }).catch(() => {})
        }
    },
};
</script>
